// Save-time thumbnail generation for the model viewer (multiple-scan mode,
// shown in the dashboard grid).

const THUMBNAIL_SIZE = 200;

// the camera pose at creation, before the user moves it (used for thumbnail
// generation).
export function cameraPose(camera) {
  return {
    position: camera.position.clone(),
    quaternion: camera.quaternion.clone(),
    up: camera.up.clone(),
    zoom: camera.zoom,
  };
}

function applyCameraPose(camera, pose) {
  camera.position.copy(pose.position);
  camera.quaternion.copy(pose.quaternion);
  camera.up.copy(pose.up);
  camera.zoom = pose.zoom;
  camera.updateProjectionMatrix();
}

// swap every mesh to its original (textured, non-wireframe) material, so the
// thumbnail always shows the "textureOn" look whatever render mode the user
// is in. The measured mesh has no original material to go back to — so it's
// enough to only drop the wireframe.
function forceTexturedMaterials(scene) {
  scene.traverse((child) => {
    if (!child.isMesh) return;
    if (child.userData.originalMaterial) {
      child.material = child.userData.originalMaterial;
    }
    if (child.material) child.material.wireframe = false;
  });
}

// Snapshot the viewer canvas into a small square thumbnail, cropped to the
// center, from the model's initial camera pose with textures on.
// `three` is the viewer's three.js state ({ gl, scene, camera }) extended
// with the initial camera pose (from cameraPose()).
export function captureThumbnail(three) {
  if (!three) return null;
  try {
    const { gl, scene, camera, initialPose } = three;
    forceTexturedMaterials(scene);
    applyCameraPose(camera, initialPose);
    scene.background = null; // render on a transparent background
    gl.setClearAlpha(0);
    gl.render(scene, camera);
    const source = gl.domElement;
    const crop = Math.min(source.width, source.height);
    const canvas = document.createElement("canvas");
    canvas.width = THUMBNAIL_SIZE;
    canvas.height = THUMBNAIL_SIZE;
    canvas
      .getContext("2d")
      .drawImage(
        source,
        (source.width - crop) / 2,
        (source.height - crop) / 2,
        crop,
        crop,
        0,
        0,
        THUMBNAIL_SIZE,
        THUMBNAIL_SIZE,
      );
    return canvas.toDataURL("image/png");
  } catch {
    return null; // no thumbnail then — not worth failing the save over
  }
}
